import { CheckCircleIcon, InfoIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Divider,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import React, { useContext, useState } from "react";
import { appRequest } from "routes";
import {
  handleSaveData,
  transformData,
} from "../../common/PRYViewer/component/utils/functions";
import { transformToinitialOrgAndEditedFormat } from "../../common/fields/utils/functions";
import { combineValues } from "../../common/function";
import HeadingSS from "../../common/Heading/HeadingSS";
import { transformDataForInitial } from "../../common/ViewerModal/utils/function";

type ModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  selectedRows: any[];
  setSelectedRows: React.Dispatch<React.SetStateAction<any[]>>;
  commentModel: {
    selectedStatus: string;
    open: boolean;
    comment: string;
  };
  handleClose?: any;
  setCommentModel: React.Dispatch<
    React.SetStateAction<{
      selectedStatus: string;
      open: boolean;
      comment: string;
      isMulti?: boolean;
    }>
  >;
  handleGet: () => void;
  view: boolean;
  width?: any;
  editedValues?: any;
  isMulti?: boolean;
  isTable?: boolean;
  isWord?: boolean;
  isSchema?: boolean;
  selectedFile?: any;
  isMdm?: boolean;
  createNew?: any;
  additionalFields?: any;
  workflowProcess?: any;
  userType?:any
};

export default function CommentDrawer({
  isOpen,
  selectedRows,
  setSelectedRows,
  commentModel,
  setCommentModel,
  handleGet,
  width,
  handleClose,
  editedValues,
  isMulti,
  isTable,
  isWord,
  isSchema,
  selectedFile,
  createNew,
  additionalFields,
  workflowProcess,
  userType
}: ModalProps) {
  // const { isOpen, onOpen, onClose } = useDisclosure()
  const [submitLoader, setSubmitLoader] = useState(false);
  const { toastNotify } = useContext(AppContext);
  const { accountDetails, workFlowData } = useContext(AppContext);
  function transformObject(inputObject: any) {
    const transformedObject: any = {};
    for (const key in inputObject) {
      transformedObject[key] = {
        originalValue: inputObject[key],
        editFieldValue: null,
      };
    }

    return transformedObject;
  }

  const handleSubmitMultipleData = async () => {
    try {
      let haveData: any = null;
      setSubmitLoader(true);
      const promises = selectedRows.map(async (row) => {
        try {
          let valus = null;
          if (
            !Array.isArray(row.values) &&
            isMulti &&
            workFlowData?.fileViewer?.approvalModalOption === "mdm"
          ) {
            if (Array.isArray(row?.values?.values?.results)) {
              row.values.values = handleSaveData(
                transformData(row?.values?.values?.results)
              );
            }
          }

          if (
            !Array.isArray(row?.values?.values) &&
            isMulti &&
            (workFlowData?.fileViewer?.approvalModalOption === "fields" ||
              workFlowData?.fileViewer?.approvalModalOption ===
                "files_verification")
          ) {
            if (Array.isArray(row?.values?.values?.results)) {
              const transformed = row?.values?.values?.results.map(
                (result: any) => {
                  return transformToinitialOrgAndEditedFormat(result?.fields);
                }
              );

              row.values.values = { results: transformed };
            }
          }

          if (isMulti) {
            valus = Array.isArray(row.values)
              ? row?.values?.[row.values?.length - 1]?.values
              : row?.values?.values;
          } else {
            if (workFlowData?.fileViewer?.approvalModalOption === "isCurebay") {
              valus = editedValues;
            } else if (isWord) {
              valus = editedValues;
            } else if (
              workFlowData?.fileViewer?.approvalModalOption === "mdm"
            ) {
              valus = editedValues;
            } else if (
              workFlowData?.fileViewer?.approvalModalOption === "fields" ||
              workFlowData?.fileViewer?.approvalModalOption ===
                "files_verification"
            ) {
              valus = editedValues;
            } else {
              if (isTable) {
                valus = Array.isArray(row.values)
                  ? row?.values?.[row.values?.length - 1]?.values
                  : row?.values?.values;
              } else if (isSchema) {
                valus = editedValues;
              } else {
                valus = combineValues(
                  Array.isArray(row.values)
                    ? row.values
                    : transformObject(row.values?.values),
                  editedValues || {}
                );
              }
            }
          }

          const updatedStatus = {
            id: row?._id,
            level: accountDetails?.level,
            status: commentModel.selectedStatus,
            comment: commentModel.comment,
            values: valus,
            type: isWord ? "word" : "document",
            activeWorkflow: workFlowData?._id,
            fileId: selectedFile?._id,
            sendNot: workFlowData?.updateFirstUserNotification,
            ...workflowProcess,
          };
          const response: any = await appRequest(
            "document",
            userType === "tester" ? "tester" : "initiateDocument",
            updatedStatus
          );

          if (response.status !== "success") {
            toastNotify({
              title: "Error",
              message:
                typeof response?.data === "string"
                  ? response?.data
                  : "Something went wrong, please contact the administration",
              type: "error",
            });
            return;
          }

          handleGet();
          setCommentModel({
            open: false,
            comment: "",
            selectedStatus: "approved",
          });

          if (handleClose) {
            handleClose();
          }
        } catch (error: any) {
          return {
            title: "Error",
            message: error.message,
            type: "error",
          };
        }
      });

      let notifications: any = await Promise.all(promises);
    } catch (err) {
      console.error(err);
      toastNotify({
        title: "Error",
        message: "Failed to update document.",
        type: "error",
      });
    } finally {
      setSubmitLoader(false);
    }
  };

  return (
    <>
      <Drawer
        placement="bottom"
        isOpen={isOpen}
        onClose={() => {
          setCommentModel({
            open: false,
            comment: "",
            selectedStatus: "approved",
          });
          // setSelectedRows([]);
        }}
        size="sm"
      >
        <DrawerOverlay />
        <DrawerContent
          boxSize={{ base: "auto", lg: `${width}` }}
          maxH="33vh"
          ml="auto"
          my="auto"
          borderRadius="md"
        >
          <DrawerHeader>
            <HeadingSS
              headingSS={
                commentModel?.selectedStatus === "approved"
                  ? "Add Your Approval Comment"
                  : "Add Your Rejection Comment"
              }
            />{" "}
          </DrawerHeader>
          <DrawerBody>
            <Textarea
              value={commentModel.comment}
              onChange={(e: any) => {
                setCommentModel({ ...commentModel, comment: e.target.value });
              }}
              placeholder="Type your comment here..."
            />
          </DrawerBody>
          <DrawerFooter>
            <Flex justify="flex-end">
              <Button
                fontSize="sm"
                w="5rem"
                bg="green.400"
                _hover={{ bg: "green.500" }}
                color="white"
                mr={3}
                isLoading={submitLoader}
                onClick={async () => {
                  if (createNew) {
                    let originalValues = transformDataForInitial(
                      editedValues?.fields
                    );
                    try {
                      setSubmitLoader(true);
                      let payload = {
                        ...additionalFields,
                        file: {
                          ...additionalFields?.file,
                          file: additionalFields?.file?.file?.split(",").pop(),
                        },
                        type: additionalFields?.type || "schema",
                        values: { valuesData: editedValues },
                        originalValues: originalValues,
                      };

                      const response: any = await appRequest(
                        "document",
                        userType === "tester" ? "tester" : "create",
                        payload
                      );

                      if (response?.status === "success") {
                        toastNotify({
                          type: "success",
                          title: "document created",
                          message: "Document Created Succesfully",
                        });
                        setCommentModel({
                          open: false,
                          comment: "",
                          selectedStatus: "approved",
                        });
                        handleClose();
                        handleGet();
                        setSubmitLoader(false);
                        return;
                      }
                    } catch (err: any) {
                      console.log(err?.message);
                      setSubmitLoader(false);
                      toastNotify({
                        title: "Error",
                        message: err?.message,
                        type: "error",
                      });
                      return;
                    } finally {
                      setSubmitLoader(false);
                      return;
                    }
                  }

                  const status = commentModel.selectedStatus;
                  const comment = commentModel.comment?.trim() || "";

                  if (
                    (status === "rejected" || status === "approved") &&
                    comment === ""
                  ) {
                    toastNotify({
                      type: "error",
                      message:
                        "Please add a comment before approving or rejecting.",
                    });
                  } else {
                    handleSubmitMultipleData();
                  }
                }}
              >
                <Text>Yes</Text>
              </Button>
              <Button
                w="5rem"
                colorScheme="red"
                fontSize="sm"
                onClick={() => {
                  setCommentModel({
                    open: false,
                    comment: "",
                    selectedStatus: "approved",
                  });
                  setSelectedRows([]);
                }}
              >
                No
              </Button>
            </Flex>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}